import React from 'react';
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from 'moment';
import {isEmpty, get} from 'lodash'
import { getSymbolFromCurrency } from "currency-symbol-map";

import authorizationService from '../../services/AuthorizationService';
@connect ((store) =>{
	return {
		user: store.user.user,
		messages: store.messages.messages,
		calendar: store.billingAccount.calendar,
		invoice: store.invoice,
		subscription: store.subscription.subscription,
		account: store.account
	}
})
export default class SubscriptionDetails extends React.Component {
	constructor() {
		super();
	};

	componentDidMount() {}

	render() {
		const { messages, calendar, invoice, account, subscription } = this.props;
		const { myInvoices = [], nextInvoiceDate, dueDate} = invoice;
		const { userAccount = {}} = account || {} ;
		const { code: subCode="", status: subscStatus="", subscriptionDate="", offer={}, services=[], subscribedTillDate= "", subscriptionRenewal: {autoRenew = false}, statusDate } = subscription || {};
		
		const invoicesFiltered = !!myInvoices && myInvoices.filter(invoice => !!invoice.invoiceNumber)
		const latestDue = !!invoicesFiltered && Math.max.apply(Math, invoicesFiltered.map(invoice => invoice.invoiceDate));
		const lastInvoice = !!invoicesFiltered && invoicesFiltered.find(invoice => invoice.invoiceDate === latestDue) || {};
		let displayNextInvoice ="" ;
		const { calendarType, days } = calendar || "";
		const currentDate = moment(Date.now()).format("YYYY/MM/DD");
		const date = new Date(currentDate);

		const {billingAccount= {}} = userAccount  || {}
		const {customerAccount= {}} = billingAccount || {}
		const CF_CUST_MEMBER_ID = get(customerAccount, `cfValues.valuesByCode.${CUSTOMER_MEMBER_ID}.0.value`, null);

		const { offerDesc = "", medias = []} = offer;
		const { mediaPath } = medias && medias[0];
        const offerImage = mediaPath || DEFAULT_OFFER_IMAGE;

		const serviceTry = !!services && services.find(service => service.code === serviceInstanceTry);
		const endAgreementDateofTry = !!serviceTry && new Date(serviceTry.endAgreementDate);

		const { totalInvoiceBalance } = customerAccount || {};
		const {paymentMethods=[]} = customerAccount || [];
		const paymentMethod = !!paymentMethods && paymentMethods.find(paymentMethod => {
			const {paymentType="", preferred=""} = paymentMethod || "";
			if ((paymentType === "DIRECTDEBIT" || paymentType === "CARD") && preferred === true) {
				return paymentMethod;
			}
		})
		const {mandateIdentification, paymentType=""} = paymentMethod || "";
		let messageToDisplay = "";
		if (paymentType === "CARD") {
			const { monthExpiration, yearExpiration } = paymentMethod || {};
			const compareYear = date.getFullYear() - yearExpiration;
			const compareMonth = date.getMonth() - monthExpiration;
			if (compareYear === 0 && compareMonth <= 3) {
				messageToDisplay = messages["common.block.soon.expired"];
			} else {
				messageToDisplay = messages["common.block.active.paymentMethod"];
			}
		} else if (paymentType === "DIRECTDEBIT") {
			messageToDisplay = messages["common.block.sepa.paymentMethod"]
		};

		const balance = !!totalInvoiceBalance &&  totalInvoiceBalance > 0 ? totalInvoiceBalance : `-${totalInvoiceBalance}`;

		const symbol = !!customerAccount && getSymbolFromCurrency(customerAccount.currency);
		const { subscriptionRenewal } = subscription || {};
		const status = !!subscription && (subscStatus === "TERMINATED" || subscStatus === "RESILIATED") ? messages["common.label.resiliated"] : messages["common.label.active"];
		//const dateByStatus = !!subscription && (subscStatus === "TERMINATED" || subscStatus === "RESILIATED") ? moment(subscription.terminationDate).format("DD/MM/YYYY") : moment(subscription.subscriptionDate).format("DD/MM/YYYY");
		let resiliationDate = !!subscription && new Date(subscription.terminationDate);
		resiliationDate = new Date(resiliationDate);
		let dateCloture = new Date(currentDate);
		if (calendarType === "YEARLY" && status === messages["common.label.resiliated"]) {
			days.forEach((day, index) => {
				if (day.month === month[resiliationDate.getMonth()].toUpperCase()) {
					if (resiliationDate.getDate() < day.day) {
						dateCloture.setDate(day.day)
					}
					if (resiliationDate.getDate() > day.day) {
						if (index === days.length - 1) {
							index = -1;
							dateCloture.setDate(days[index + 1].day);
							dateCloture.setMonth(dateCloture.getMonth() + 1);
						} else {
							dateCloture.setDate(days[index + 1].day);
							dateCloture.setMonth(dateCloture.getMonth() + 1);
						}
					}
				}
				if (dateCloture >= date ) {
					displayNextInvoice = true
				} else {
					displayNextInvoice = false
				}
			})
		}
		const displayDueDate  = !!serviceTry && moment(endAgreementDateofTry).isAfter() ;

		// Offer image styles
		const offerImageStyle= { maxHeight: '120px' };
		// Offer desicription for My SERVICES box
		const auth = authorizationService.auth;
		const locale = (!!auth &&  !!auth.tokenParsed && auth.tokenParsed.locale) || "es";
		const offerLongDescription = (Object.entries(offer.longDescriptionI18n).find(([languageCode]) => languageCode === LANGUAGE_PREFIX[locale]) || [])[1];
		const servicesDescription = offerLongDescription || offer.longDescription || "";
		/* ------------------ */
		return (
			!isEmpty(subscription) &&
			<div id="SubscriptionDetails">
				<div className="col-md-12">
					<div className="col-md-8">
						<p className="title stat-panel">{messages["common.label.my.subscription"]}</p>
					</div>
					<div className="col-md-6">
						<div className="text-left">
							<p className="sousTitle title-of-box">{messages["common.label.general.info"]}</p>
						</div>
						<div className="box-amount-wide marginLeftBox">
							<div className="text-left col-md-8" >
								<h5 ><label className="card-title">{offerDesc}</label></h5>
								<h5 className="small-size"><label className="text-label grey-blue-color"> {messages["common.label.souscribe"]} : </label> <label className="text-value">{moment(subscriptionDate).format("DD/MM/YYYY")}</label></h5>
								<h5 className="small-size"> <label className="text-label grey-blue-color"> {messages["common.label.num.contrat"]} : </label><label className="text-value">{subCode}</label></h5>
								<h5 className="small-size"> <label className="text-label grey-blue-color"> {messages["common.label.num.card"]} : </label><label className="text-value">{CF_CUST_MEMBER_ID}</label></h5>
							</div>
							{medias && (
								<div className="col-md-3" >
									<img
										src={offerImage}
										onError={(e) => {
											e.target.src = DEFAULT_OFFER_IMAGE;
										}}
										style={offerImageStyle}
									/>
								</div>
							)}
							<div className="text-left col-md-9" >
							</div>
						</div>
						<div className="stat-panel">
							<div className="text-left">
								<h5 className="sousTitle title-of-box" >
									{messages["common.label.services"]}
								</h5>
							</div>
							<div className="box-amount-small">
								<div className="text-left" >
									<div class="col-md-12" >
									{servicesDescription.split('-').map((item, key) => {
										return (
											<li style={{ "listStyleType": " disc" }} key={key}>
												{item}
												<br />
											</li>
										)
									})}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-5">
					<div className="stat-panel">
							<h5 className="sousTitle title-of-box">
								{messages["common.label.my.invoices"]}</h5>
							<div className="box-amount-small">

								{!!lastInvoice && !!lastInvoice.invoiceDate &&
									<div className="text-left" >
										<div class="col-md-12" >
											<p> <label className="text-label grey-blue-color">{messages["common.label.last.invoice"]}</label> {": "} <label className="text-value" >{moment(lastInvoice.invoiceDate).format("DD/MM/YYYY")}</label></p>
										</div>
									</div>
								}
								{totalInvoiceBalance > 0 &&
									<div className="text-left">
										<div class="col-md-12  borderDiv">
											<i className="fa fa-exclamation-triangle" /> <label className="text-label grey-blue-color" >{messages["common.label.amount.unpaid"]}{": "}</label><label className="text-value">{balance} {symbol} </label>
										</div>
									</div>
								}
								{status === messages["common.label.active"] || displayNextInvoice ?
									<div class="col-md-12" >
										{nextInvoiceDate && <p> <label className="text-label grey-blue-color">{messages["common.label.next.invoice"]}</label> {": "} <label className="text-value">{nextInvoiceDate && moment(nextInvoiceDate).format("DD/MM/YYYY")}</label></p>}
										{displayDueDate && <p ><label className="text-label grey-blue-color"> {messages["common.label.levied"]}</label> {": "} <label className="text-value">{moment(dueDate).format("DD/MM/YYYY")}</label></p>}

									</div>
									: null
								}

								<div className="text-center">
									<Link to={myInvoicesDetails_url.path}>
										<button className="btn btn-theme-default">{messages["common.button.see.all.bills"]}</button>
									</Link>
								</div>
							</div>
						</div>

						<div className="stat-panel">
							<h5 className="sousTitle title-of-box" >
								{messages["common.label.manage.subscription"]}
							</h5>
							<div className="box-amount-small">
								<p className="box-text">{messages["common.block.manage.sub.by.status"].replace("${status}", status).replace("$date", moment(statusDate).format("DD/MM/YYYY"))}</p>
								{!!subscription && subscStatus != "TERMINATED" && subscStatus != "RESILIATED" && !autoRenew && <p className="box-text">{messages["common.block.renew.off"].replace("${status}", status).replace("$terminationDate", subscribedTillDate ? moment(subscribedTillDate).format("DD/MM/YYYY") : messages["common.block.comment.subscription.end.date"])}</p>}

								{!!subscription && subscStatus != "TERMINATED" && subscStatus != "RESILIATED" &&
									<div className="text-center">
										<Link to={manageSubscription_url.path}>
											<button className="btn btn-theme-default">{messages["common.button.update"]}</button>
										</Link>
									</div>
								}
							</div>
						</div>
						<div className="stat-panel">
							<div className="text-left">
								<h5 className="sousTitle title-of-box" >
									{messages["common.label.manage.payment.method"]}
								</h5>
							</div>
							<div className="box-amount-small">
								{messages["common.block.soon.expired"] === messageToDisplay ?
									<p className="box-text warning-text">{messageToDisplay}</p>
									:
									<p className="box-text">{messageToDisplay}</p>
								}
								<div className="amount text-center" >
									<Link to={mesCoordonnees_url.path}>
										<button className="btn btn btn-theme-default">{messages["common.label.manage.my.payment.method"]}</button>
									</Link>
								</div>
							</div>
						</div>
						{/* <div className="stat-panel">
							<div className="text-left">
								<h5 className="sousTitle title-of-box" >
									{messages["common.label.my.documents"]}
								</h5>
							</div>
							<div className="box-amount-small">
								<div className="text-center">
									<div className="col-md-12 link-anchor">
										<a onClick={!!subscription && this.downloadSignedPdf("Contrat")}>{messages["common.label.contrat"]}</a>
								 	</div>
									<div className="col-md-12 link-anchor">
										<a onClick={!!subscription && this.downloadSignedPdf("SEPA")} disabled={!foundSepaFile}>{messages["common.label.mondat.sepa"]}</a> 
									 </div>
									<div className="col-md-12 link-anchor">
										<a onClick={!!subscription && this.downloadSignedPdf("TERMS")}>{messages["common.label.terms"]}</a>
									 </div>
								</div>
							</div>
						</div> */}
						{/* <div className="stat-panel">
							<div className="text-left">
								<h5 className="sousTitle title-of-box" >
									{messages["common.label.my.advice"]}
								</h5>
							</div>
							<div className="box-amount-small">
								<p>{messages["common.block.conseil"]}</p>
								<Link to={mesConseils_url.path}>
									<div className="amount text-center" >
										<button className="btn btn-theme-default">{messages["common.button.see.my.advice"]}</button>
									</div>
								</Link>
							</div>
						</div> */}
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/opencell/pages/client/SubscriptionDetails.jsx